import React from "react";
import { observer } from "mobx-react";
import { ShowcaseLineViewStore } from "../../store";
import { ShowcaseLineViewForm } from "./ShowcaseLineViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type ShowcaseLineViewProps = {
  showcaseLineViewStore: ShowcaseLineViewStore;
};

export const ShowcaseLineView: React.FC<ShowcaseLineViewProps> = observer(
  ({ showcaseLineViewStore }) => {
    return (
      <div>
        <ShowcaseLineViewForm
          concept={showcaseLineViewStore.conceptValue}
          quantity={showcaseLineViewStore.quantityValue}
          unitPrice={showcaseLineViewStore.unitPriceValue}
          note={showcaseLineViewStore.noteValue}
          onPrint={(handlePrint: () => void) =>
            showcaseLineViewStore.printShowcaseLine(handlePrint)
          }
          onCancel={() => showcaseLineViewStore.cancelShowcaseLine()}
          onEdit={
            showcaseLineViewStore.isEditEnabled
              ? () => showcaseLineViewStore.editShowcaseLine()
              : undefined
          }
        />
        <ErrorDialog
          open={showcaseLineViewStore.errorDialogOpened}
          title={showcaseLineViewStore.errorTitle}
          description={showcaseLineViewStore.errorDescription}
          onClose={() => showcaseLineViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
